/**
 * 將自訂驗證 issues 寫入 RHF setError（type: manual），供欄位紅框使用。
 *
 * @param {Function} setError - react-hook-form setError
 * @param {{ path: string, message: string }[]} issues
 * @param {object} [options]
 * @param {Function} [options.clearErrors] - 可選；寫入前先清除
 * @param {string[]} [options.pathsToClear] - 傳給 clearErrors 的路徑；
 *   省略且有 clearErrors 時呼叫 clearErrors()（全清）
 */
export function applyManualFieldErrors(setError, issues, options = {}) {
  const { clearErrors, pathsToClear } = options;
  const list = Array.isArray(issues) ? issues : [];

  if (typeof clearErrors === 'function') {
    if (Array.isArray(pathsToClear)) {
      if (pathsToClear.length > 0) {
        clearErrors(pathsToClear);
      }
    } else {
      clearErrors();
    }
  }

  list.forEach((issue) => {
    if (!issue?.path || !issue?.message) {
      return;
    }
    setError(issue.path, { type: 'manual', message: issue.message });
  });
}

export default applyManualFieldErrors;
